export default __webpack_public_path__ + "static/media/day.d9ea231c.svg";